import Loader from "react-loader-spinner";
import { useHistory } from 'react-router-dom';
import { PencilSquare, DashCircle, PlusSquare, Trash, Search, ArrowReturnLeft } from 'react-bootstrap-icons';
import { Table, Modal, Button, Form } from 'react-bootstrap';
import { useDispatch, useSelector } from "react-redux";
import { addEditProductGroup, addEditProductMainGroup, deleteProductGroup, deleteProductMainGroup, getAllProductMainGroups, getProductGroups } from '../store/api/GetAllProduct';
import { useEffect, useRef, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBoxes, faTimes } from "@fortawesome/free-solid-svg-icons";
const ModalAddEditProductGroup = () => {
    const history = useHistory();
    const [mainEditMode, setMainEditMode] = useState(false);
    const [groupEditMode, setGroupEditMode] = useState(false);
    const notForSelect = useRef(false);
    const currentMainGroup = useRef({});
    const currentGroup = useRef({});
    const { mainGroupList, groupList } = useSelector(state => {
        return {
            mainGroupList: state.ProductReducer.productMainGroupList,
            groupList: state.ProductReducer.productGroupList
        }
    });
    const dispatch = useDispatch();

    const close = () => {
        history.goBack();
    }
    const searchGroups = (mainG) => {
        const tr = mainG.event.target.closest(".resultTableRow");
        const modal = document.getElementById("modalAddEditProductGroup");
        modal.querySelectorAll(".selectedResultTableRow").forEach(el => el.classList.remove("selectedResultTableRow"));
        if (tr) {
            tr.classList.add("selectedResultTableRow");
        }
        if (notForSelect.current) {
            notForSelect.current = false;
            return;
        }
        currentMainGroup.current = mainG.mainGroup;
        dispatch(getProductGroups(mainG.mainGroup.MainGroupID));
    }
    const addOrUpdateMainG = () => {
        const onSuccess = () => {
            currentMainGroup.current = {};
            if (mainEditMode) {
                setMainEditMode(false);
            }
            else {
                const frm = document.getElementById("frmMainGroup");
                frm.reset();
            }
        }
        if (!currentMainGroup.current.MainGroupCode ||
            currentMainGroup.current.MainGroupCode === '' ||
            !currentMainGroup.current.MainGroupName ||
            currentMainGroup.current.MainGroupName === '') {
            return;
        }
        if (!mainEditMode) {
            currentMainGroup.current.MainGroupID = 0;
        }

        dispatch(addEditProductMainGroup(currentMainGroup.current, onSuccess));
    }
    const addOrUpdatePG = () => {
        const onSuccess = () => {
            currentGroup.current = {};
            if (groupEditMode) {
                setGroupEditMode(false);
            }
            else {
                const frm = document.getElementById("frmGroup");
                frm.reset();
            }
        }
        if (!currentGroup.current.GroupCode ||
            currentGroup.current.GroupCode === '' ||
            !currentGroup.current.GroupName ||
            currentGroup.current.GroupName === '') {
            return;
        }
        currentGroup.current.MainGroupID = currentMainGroup.current.MainGroupID;
        if (!groupEditMode) {
            currentGroup.current.GroupID = 0;
        }
        dispatch(addEditProductGroup(currentGroup.current, onSuccess));
    }
    const setMainToEditMode = (mainG) => {
        notForSelect.current = true;
        if (mainEditMode) {
            return;
        }
        currentMainGroup.current = mainG;
        setMainEditMode(true);
    }
    const setGroupToEditMode = (group) => {
        currentGroup.current = group;
        setGroupEditMode(true);
    }
    const cancelMainEditMode = () => {
        currentMainGroup.current = {};
        setMainEditMode(false);
    }
    const cancelEditMode = () => {
        currentGroup.current = {};
        setGroupEditMode(false);
    }
    const deleteGroup = (id) => {

        dispatch(deleteProductGroup(id));
    }
    const deleteMain = (id) => {
        notForSelect.current = true;
        dispatch(deleteProductMainGroup(id));
    }
    function findInTable(e,name) {
        if(e.key && e.key !=="Enter")
        {
            return;
        }
        const modal = document.getElementById("modalAddEditProductGroup");
        modal.querySelectorAll(".selectedResultTableRow").forEach(el => el.classList.remove("selectedResultTableRow"));
        const table = document.getElementById("tbl"+name);
        const txt = document.getElementById("txtFind"+name).value;
        if(!txt || txt === "")
        {
            return;
        }
        for(let i = 1; i <table.rows.length; i++)
        {
            const row = table.rows[i];
            const groupName =row.cells[1].firstChild?.data;
            if(groupName.includes(txt) )
            {
                row.scrollIntoView({
                    behavior: 'smooth',
                    block: 'center'
                });
                    row.classList.add("selectedResultTableRow");
            }
        }
    }
    useEffect(() => {
        dispatch(getAllProductMainGroups());
        dispatch(getProductGroups());
    }, []);
    return (
        <Modal id="modalAddEditProductGroup" show={true} size="lg" style={{ direction: "rtl" }} onHide={() => { }}>
            <Modal.Header className="headerStyle">
                <span> <FontAwesomeIcon icon={faBoxes} size="lg" style={{ marginLeft: "3px" }} /> مدیریت گروهبندی کالا </span><FontAwesomeIcon icon={faTimes} size="lg" onClick={close} />
            </Modal.Header>
            <Modal.Body className="bodyStyle">
                <div className="row" >
                    <div className="col-md-6 hideScroll">
                        <p style={{ color: "black", margin: "0", fontWeight: "bold" }}>گروه های اصلی</p>
                        <hr style={{ margin: "5px", color: "blue", height: "2px" }} />
                        <input type="hidden" value={mainEditMode} readOnly />
                        <div>
                            <Form.Control className="tableRowInput" placeholder="جستجوی گروه اصلی" id="txtFindMainGroups" onKeyDown={e=>(findInTable(e,"MainGroups"))}/>
                            <Button className="btn-input-tiny" style={{ top: "2px", left: "2px" }} onClick={e => findInTable(e,"MainGroups")}><Search size={18} /></Button>
                        </div>
                        <Table responsive className="fixedTable mt-2" id="tblMainGroups">
                            <thead>
                                <tr>
                                    <th style={{ width: "20%" }}>کد گروه</th>
                                    <th style={{ width: "60%" }}>نام گروه</th>
                                    <th style={{ width: "20%" }}>&nbsp;</th>
                                </tr>
                            </thead>
                            <tbody>
                                {(mainGroupList === "PENDING") &&
                                    <tr>
                                        <td colSpan={3} style={{ textAlign: "center" }}>
                                            <Loader type="BallTriangle" color="rgb(228, 3, 117)" height={20} width={20} />
                                        </td>
                                    </tr>
                                }
                                {mainGroupList && Array.isArray(mainGroupList) &&
                                    mainGroupList.map((item, i) =>
                                        <tr key={i} className="resultTableRow" onClick={(e) => searchGroups({ mainGroup: item, event: e })}>
                                            <td style={{ width: "20%" }}>{item.MainGroupCode}</td>
                                            <td style={{ width: "60%" }}>{item.MainGroupName}</td>
                                            <td style={{ width: "20%" }}>
                                                <PencilSquare className="rowBtn" color="#eb6e34" size={16} onClick={() => setMainToEditMode(item)} />
                                                &nbsp;
                                                <Trash className="rowBtn" color="red" size={16} onClick={() => deleteMain(item.MainGroupID)} />
                                            </td>
                                        </tr>
                                    )
                                }
                            </tbody>
                        </Table>
                        {!mainEditMode &&
                            <form id="frmMainGroup">
                                <div className="row">
                                    <div className="col-md-3" style={{ padding: "3px", paddingRight: "10px" }}>
                                        <input type="text" className="tableRowInput" placeholder="کد گروه" onChange={e => currentMainGroup.current.MainGroupCode = e.target.value} />
                                    </div>
                                    <div className="col-md-7" style={{ padding: "3px" }}>
                                        <input type="text" className="tableRowInput" placeholder="نام گروه" onChange={e => currentMainGroup.current.MainGroupName = e.target.value} />
                                    </div>
                                    <div className="col-md-1" style={{ padding: "2px" }}>
                                        <Button className="group-Btn-smalll" onClick={addOrUpdateMainG}><PlusSquare size={18} /></Button>
                                    </div>
                                </div>
                            </form>
                        }
                        {mainEditMode &&
                            <div className="row">
                                <div className="col-md-3" style={{ padding: "3px", paddingRight: "10px" }}>
                                    <input type="text" className="tableRowInput" defaultValue={currentMainGroup.current.MainGroupCode ? currentMainGroup.current.MainGroupCode : ""}
                                        onChange={e => currentMainGroup.current.MainGroupCode = e.target.value} />
                                </div>
                                <div className="col-md-6" style={{ padding: "3px" }}>
                                    <input type="text" className="tableRowInput" defaultValue={currentMainGroup.current.MainGroupName ? currentMainGroup.current.MainGroupName : ""}
                                        onChange={e => currentMainGroup.current.MainGroupName = e.target.value} />
                                </div>
                                <div className="col-md-3" style={{ padding: "2px" }}>
                                    <Button variant="info" className="group-Btn-smalll" onClick={addOrUpdateMainG}><PencilSquare size={18} /></Button>
                                    <Button variant="danger" className="group-Btn-smalll" onClick={cancelMainEditMode}><DashCircle size={18} /></Button>
                                </div>
                            </div>
                        }
                    </div>
                    <div className="col-md-6 hideScroll">
                        <p style={{ color: "black", margin: "0", fontWeight: "bold" }}>{'گروه های فرعی ' + (!mainEditMode && currentMainGroup.current.MainGroupName ? '[ ' + currentMainGroup.current.MainGroupName + ' ]' : '')}</p>
                        <hr style={{ margin: "5px", color: "blue", height: "2px" }} />
                        <div>
                            <Form.Control className="tableRowInput" placeholder="جستجوی گروه فرعی" id="txtFindGroups" onKeyDown={e=>(findInTable(e,"Groups"))}/>
                            <Button className="btn-input-tiny" style={{ top: "2px", left: "2px" }} onClick={e => findInTable(e,"Groups")}><Search size={18} /></Button>
                        </div>
                        <Table responsive className="fixedTable mt-2" id="tblGroups">
                            <thead>
                                <tr>
                                    <th style={{ width: "20%" }}>کد گروه</th>
                                    <th style={{ width: "60%" }}>نام گروه</th>
                                    <th style={{ width: "20%" }}>&nbsp;</th>
                                </tr>
                            </thead>
                            <tbody>
                                {(groupList === "PENDING") &&
                                    <tr>
                                        <td colSpan={3} style={{ textAlign: "center" }}>
                                            <Loader type="BallTriangle" color="rgb(228, 3, 117)" height={20} width={20} />
                                        </td>
                                    </tr>
                                }
                                {groupList && Array.isArray(groupList) &&
                                    groupList.map((item, i) =>
                                        <tr key={i} className="resultTableRow">
                                            <td style={{ width: "20%" }}>{item.GroupCode}</td>
                                            <td style={{ width: "60%" }}>{item.GroupName}</td>
                                            <td style={{ width: "20%" }}>
                                                <PencilSquare className="rowBtn" color="#eb6e34" size={16} onClick={() => setGroupToEditMode(item)} />
                                                &nbsp;
                                                <Trash className="rowBtn" color="red" size={16} onClick={() => deleteGroup(item.GroupID)} />
                                            </td>
                                        </tr>
                                    )
                                }
                            </tbody>
                        </Table>
                        {!groupEditMode &&
                            <form id="frmGroup">
                                <div className="row">
                                    <div className="col-md-3" style={{ padding: "3px", paddingRight: "10px" }}>
                                        <input type="text" className="tableRowInput" placeholder="کد گروه" onChange={e => currentGroup.current.GroupCode = e.target.value} />
                                    </div>
                                    <div className="col-md-7" style={{ padding: "3px" }}>
                                        <input type="text" className="tableRowInput" placeholder="نام گروه" onChange={e => currentGroup.current.GroupName = e.target.value} />
                                    </div>
                                    <div className="col-md-1" style={{ padding: "2px" }}>
                                        <Button className="group-Btn-smalll" onClick={addOrUpdatePG}><PlusSquare size={18} /></Button>
                                    </div>
                                </div>
                            </form>
                        }
                        {groupEditMode &&
                            <div className="row">
                                <div className="col-md-3" style={{ padding: "3px", paddingRight: "10px" }}>
                                    <input type="text" className="tableRowInput" defaultValue={currentGroup.current.GroupCode ? currentGroup.current.GroupCode : ""}
                                        onChange={e => currentGroup.current.GroupCode = e.target.value} />
                                </div>
                                <div className="col-md-6" style={{ padding: "3px" }}>
                                    <input type="text" className="tableRowInput" defaultValue={currentGroup.current.GroupName ? currentGroup.current.GroupName : ""}
                                        onChange={e => currentGroup.current.GroupName = e.target.value} />
                                </div>
                                <div className="col-md-3" style={{ padding: "2px" }}>
                                    <Button variant="info" className="group-Btn-smalll" onClick={addOrUpdatePG}><PencilSquare size={18} /></Button>
                                    <Button variant="danger" className="group-Btn-smalll" onClick={cancelEditMode}><DashCircle size={18} /></Button>
                                </div>
                            </div>
                        }
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    )
}
export default ModalAddEditProductGroup;